import { Section, Row, Col } from 'components/grid'
import React from 'react'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'
import { graphql, useStaticQuery } from 'gatsby'
import { ToolkitQueryEdge } from 'pages/intervention'
import ToolkitTabs from 'components/intervention/ToolkitTabs'
import SectionTitle from 'components/global/SectionTitle'

export default function ENILToolkits({ ...props }) {
	const data = useStaticQuery<ToolkitQuery>(query)

	const { enil } = data

	return (
		<Section id={formatSectionId(props)} className="mt-20 scroll-mt-14">
			<SectionTitle
				title="ENIL Toolkits (Herramientas ENIL)"
				text={[
					<span key={Math.random()} className="mb-3 block">
						The ENIL<sup>®</sup> Foundational Skills Toolkits (Herramientas para el desarrollo de Destrezas fundamentales, Amarillo–2 Rojo) are designed for
						high-dosage, differentiated small-group tutoring and intervention by the classroom teacher and/or other educators. Explicit Spanish-language skills
						instruction includes phonological and phonemic awareness, phonics, encoding/decoding, word study, fluency, and spelling.
					</span>,
					<span key={Math.random()}>The Blanco Toolkit helps teachers deliver targeted intervention in key literacy skills to intermediate grade students.</span>
				]}
			/>

			<Row>
				<Col>
					<ToolkitTabs showFrameworks toolkits={enil} />
				</Col>
			</Row>
		</Section>
	)
}

interface ToolkitQuery {
	enil: ToolkitQueryEdge
}

const query = graphql`
	query {
		enil: allContentfulToolkit(filter: { type: { eq: "ENIL" } }) {
			edges {
				node {
					...toolkit
				}
			}
		}
	}
`
